import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 col-form-label fw-bold fs-6" }, "Name:", -1)
const _hoisted_3 = { class: "col-lg-9 fv-row" }
const _hoisted_4 = {
  key: 0,
  class: "row mb-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_FullFroala = _resolveComponent("FullFroala")!
  const _component_BaseForm = _resolveComponent("BaseForm")!

  return (_openBlock(), _createBlock(_component_BaseForm, {
    submitting: _ctx.submitting,
    onFormDiscard: _ctx.onClosePanel,
    onFormSubmit: _ctx.onSavePage
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Field, {
            name: "name",
            type: "text",
            class: "form-control fw-bold",
            modelValue: _ctx.model.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.name) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      (_ctx.model.type ==='PAGE' || _ctx.model.type ==='SECTION')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_FullFroala, {
              modelValue: _ctx.model.body ,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.body ) = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["submitting", "onFormDiscard", "onFormSubmit"]))
}